import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/qt/Index/index.vue'
import shouye from '../views/qt/shouye/index.vue'
import detail from '../views/qt/gameDetai/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/gameList',
    name: 'gameList',
    component: index
  },
  {
    path: '/',
    name:"index",
    component: shouye
  },
  {
    path: '/detail',
    name:"detail",
    component: detail
  },
]

const router = new VueRouter({
  routes
})

export default router
